import React, { useEffect } from 'react';
import { Paper, CircularProgress, Typography } from '@material-ui/core';
import { get } from '../../utils/network';

const STATUS_STYLE = {
    ok:          { dot: '#3b6d11', bg: '#eaf3de', color: '#3b6d11', label: 'Connected' },
    unreachable: { dot: '#b7791f', bg: '#fdf3d9', color: '#8a5a00', label: 'Unreachable' },
    error:       { dot: '#a32d2d', bg: '#fcebeb', color: '#a32d2d', label: 'Error' },
};

const styleFor = state => STATUS_STYLE[state] || STATUS_STYLE.error;

const dot   = style => ({ width: 8, height: 8, borderRadius: '50%', flexShrink: 0, background: style.dot });
const badge = style => ({ fontSize: 11, padding: '2px 8px', borderRadius: 6, fontWeight: 500,
                       background: style.bg, color: style.color });

const CATEGORIES = ["database", "storage", "search"];

const ServicesCheckComponent = () => {
    const [status, setStatus] = React.useState(null);

    useEffect(() => {
        get('dev/status')
            .then(res => res.json())
            .then(res => setStatus(res.message))
            .catch(err => console.log(err));
    }, []);

    return (
        <Paper style={{ padding: '1rem', width: '30%' }}>
            <Typography style={{ fontSize: 20}}>Estado de servicios:</Typography>
            {status ? CATEGORIES.map(category => {
                const { type, status: state } = status[category];
                const style = styleFor(state);
                return (
                    <div key={category} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0',
                                                 borderBottom: '0.5px solid rgba(0,0,0,0.08)' }}>
                        <div style={dot(style)} />
                        <span style={{ flex: 1, fontSize: 14 }}>{type}</span>
                        <span style={badge(style)}>{style.label}</span>
                    </div>
                );
            }) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CircularProgress size={20} style={{ padding: '0.25rem' }} />
                    Cargando...
                </div>
            )}
        </Paper>
    );
};

export default ServicesCheckComponent;
